//全局参数
export default {
  baseUrl: "https://main.zhiying2023.cn",
  liveUrl: "http://175.178.183.117/live/v1",
};
